<template>
  <transition name="modal" id="product-fito-fert-add-suggestion-dialog" v-if="visible">
    <DxPopup
      class="vertical-center"
      :visible="visible"
      :show-title="true"
      :title="$t('products_catalog.create_suggestion')"
      :width="mobile ? '80%' : '350px'"
      :height="mobile ? '85%' : '400px'"
      :hide-on-outside-click="false"
      :drag-enabled="false"
      :show-close-button="true"
      :resize-enabled="true"
      @hiding="onClose"
    >
      <div style="display: flex; flex-direction: column; height: 95%">
        <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 12px"></div>

        <div class="row">
          <div class="form-group col-sm-12 col-lg-12 text-left">
            <label class="control-label">{{ $t("common.name") }}</label>
            <DxTextBox v-model="localData.name" placeholder="" :class="{ 'field-error': this.$v.localData.name.$error }"></DxTextBox>
          </div>
        </div>

        <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: auto; padding-top: 16px">
          <button type="button" class="btn btn-outline-secondary" @click="onClose">{{ $t("common.cancel") }}</button>
          <button type="button" class="btn btn-outline-primary" @click="addProductSuggestion">{{ $t("ok") }}</button>
        </div>
      </div>
      <toast-message ref="toastMessage"></toast-message>
    </DxPopup>
  </transition>
</template>

<script>
import { mapActions } from "vuex";
import DxTextBox from "devextreme-vue/text-box";
import DxPopup from "devextreme-vue/popup";
import required from "vuelidate/src/validators/required";
import ToastMessage from "@/components/Mobile/toastMessage.vue";

export default {
  name: "AddProductSuggestion",
  components: {
    DxPopup,
    DxTextBox,
    ToastMessage,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localData: { ...this.data },
      addBttnDisabled: false,
    };
  },
  methods: {
    ...mapActions({
      createProductSuggestion: "fertilityProduct/addProductSuggestion",
    }),
    onClose() {
      this.$emit("close");
    },
    addProductSuggestion() {
      if (this.addBttnDisabled) {
        return;
      }

      this.$v.$touch(); // Trigger validation
      if (this.$v.$invalid) {
        return;
      }

      this.addBttnDisabled = true;
      this.createProductSuggestion(this.localData).then(() => {
        this.$refs.toastMessage.showSuccess("Sugestia a fost adăugată cu succes!");
        setTimeout(() => {
          this.addBttnDisabled = false;
          this.onClose();
        }, 1500);
      });
    },
  },
  validations() {
    return {
      localData: {
        name: {
          required,
        },
      },
    };
  },
};
</script>
